import React, { useEffect, useState, useCallback } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Box, Typography, CircularProgress } from '@mui/material';
import Header from '../components/Header';
import { API_BASE_URL } from '../config';

const mapContainerStyle = {
  width: '100%',
  height: '75vh',
  borderRadius: '8px'
};

const center = {
  lat: 36.752887,
  lng: 3.042048
};

const DriversMap = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDrivers = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/location`);
      const data = await response.json();
      if (data.success && data.drivers) {
        const validDrivers = data.drivers
          .filter(driver => driver.latitude && driver.longitude)
          .map(driver => ({
            id: driver.id,
            latitude: parseFloat(driver.latitude),
            longitude: parseFloat(driver.longitude),
            car: driver.car || 1,
            name: `${driver.name || ''} ${driver.fname || ''}`.trim() || 'Chauffeur'
          }));
        setDrivers(validDrivers);
      }
    } catch (error) {
      console.error('Error fetching drivers location:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDrivers();
    const interval = setInterval(fetchDrivers, 10000);
    return () => clearInterval(interval);
  }, [fetchDrivers]);

  const hasGoogle = typeof window !== 'undefined' && window.google && window.google.maps;

  return (
    <Box m="20px">
      <Header title="CARTE DES CHAUFFEURS" subtitle="Localisation en temps réel des chauffeurs LinkerVTC connectés" />
      <Box mt="20px" height="75vh" backgroundColor="#1F2A40" borderRadius="8px" display="flex" justifyContent="center" alignItems="center">
        {!hasGoogle ? (
          <Box textAlign="center" color="#fff">
            <CircularProgress color="secondary" />
            <Typography mt={2}>Initialisation de la carte Google Maps...</Typography>
          </Box>
        ) : (
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={8}
            options={{
              disableDefaultUI: false,
              zoomControl: true,
            }}
          >
            {drivers.map(driver => (
              <Marker
                key={driver.id}
                position={{ lat: driver.latitude, lng: driver.longitude }}
                title={driver.name}
                icon={hasGoogle && window.google.maps.Size ? {
                  url: `/assets/cars/${driver.car}.png`,
                  scaledSize: new window.google.maps.Size(48, 30),
                } : undefined}
              />
            ))}
          </GoogleMap>
        )}
      </Box>
    </Box>
  );
};

export default DriversMap;
